import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import AnimatedTitle from '@/components/shared/AnimatedTitle.vue';
import BigButton from '@/components/shared/BigButton.vue';
import App from '@/App.vue';
import store from '@/store';

// Config
Vue.config.productionTip = false;
library.add(fal);

// Components
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('AnimatedTitle', AnimatedTitle);
Vue.component('BigButton', BigButton);

// App mounting
new Vue({
  store,
  render: h => h(App),
}).$mount('#app');
